/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccessTokenProviderDto } from './AccessTokenProviderDto';
import type { DatasourceProviderDto } from './DatasourceProviderDto';
import type { GenericProviderDto } from './GenericProviderDto';
import type { GroupIdentifierDto } from './GroupIdentifierDto';
import type { UserProviderDto } from './UserProviderDto';

export type DatapointQualificationLightNewDto = {
    comment?: string;
    createdByProvider: (AccessTokenProviderDto | DatasourceProviderDto | GenericProviderDto | UserProviderDto);
    createdDate?: number;
    group?: GroupIdentifierDto;
    id: string;
    lastModifiedDate?: number;
    modelAnomalyStatus?: DatapointQualificationLightNewDto.modelAnomalyStatus;
    modifiedByProvider: (AccessTokenProviderDto | DatasourceProviderDto | GenericProviderDto | UserProviderDto);
    userAnomalyStatus?: DatapointQualificationLightNewDto.userAnomalyStatus;
    userEvaluationStatus: DatapointQualificationLightNewDto.userEvaluationStatus;
};

export namespace DatapointQualificationLightNewDto {

    export enum modelAnomalyStatus {
        ANOMALY = 'ANOMALY',
        NOT_ANOMALY = 'NOT_ANOMALY',
    }

    export enum userAnomalyStatus {
        ANOMALY = 'ANOMALY',
        NOT_ANOMALY = 'NOT_ANOMALY',
    }

    export enum userEvaluationStatus {
        PENDING = 'PENDING',
        REVIEWED = 'REVIEWED',
    }


}
